import * as Types from '../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetResumeImprovementsQueryVariables = Types.Exact<{
  input: Types.ResumeImprovementsInput;
}>;


export type GetResumeImprovementsQuery = { __typename?: 'Query', getResumeImprovements?: { __typename?: 'ResumeImprovementsPayload', id: string, content: { __typename?: 'TailoredResumeContent', summary: { __typename?: 'TailoredResumeSummary', summary: string, rewrittenReason: string }, workExperiences: Array<{ __typename?: 'TailoredWorkExperience', id: string, description?: string | null, rewrittenReason: string }>, skills: { __typename?: 'TailoredSkillsChange', rewrittenReason: string, skills: Array<{ __typename?: 'TailoredSkill', id: string, text: string }> }, certificates: { __typename?: 'TailoredCertificatesChange', rewrittenReason: string, certificates: Array<{ __typename?: 'TailoredCertificates', id: string, title: string, description: string }> }, education: Array<{ __typename?: 'TailoredEducation', id: string, school?: string | null, additionalDetails?: string | null, rewrittenReason: string }> } } | null };


export const GetResumeImprovementsDocument = gql`
    query GetResumeImprovements($input: ResumeImprovementsInput!) {
  getResumeImprovements(input: $input) {
    id
    content {
      summary {
        summary
        rewrittenReason
      }
      workExperiences {
        id
        description
        rewrittenReason
      }
      skills {
        rewrittenReason
        skills {
          id
          text
        }
      }
      certificates {
        rewrittenReason
        certificates {
          id
          title
          description
        }
      }
      education {
        id
        school
        additionalDetails
        rewrittenReason
      }
    }
  }
}
    `;

/**
 * __useGetResumeImprovementsQuery__
 *
 * To run a query within a React component, call `useGetResumeImprovementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResumeImprovementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResumeImprovementsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetResumeImprovementsQuery(baseOptions: Apollo.QueryHookOptions<GetResumeImprovementsQuery, GetResumeImprovementsQueryVariables> & ({ variables: GetResumeImprovementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResumeImprovementsQuery, GetResumeImprovementsQueryVariables>(GetResumeImprovementsDocument, options);
      }
export function useGetResumeImprovementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResumeImprovementsQuery, GetResumeImprovementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResumeImprovementsQuery, GetResumeImprovementsQueryVariables>(GetResumeImprovementsDocument, options);
        }
export function useGetResumeImprovementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResumeImprovementsQuery, GetResumeImprovementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResumeImprovementsQuery, GetResumeImprovementsQueryVariables>(GetResumeImprovementsDocument, options);
        }
export type GetResumeImprovementsQueryHookResult = ReturnType<typeof useGetResumeImprovementsQuery>;
export type GetResumeImprovementsLazyQueryHookResult = ReturnType<typeof useGetResumeImprovementsLazyQuery>;
export type GetResumeImprovementsSuspenseQueryHookResult = ReturnType<typeof useGetResumeImprovementsSuspenseQuery>;
export type GetResumeImprovementsQueryResult = Apollo.QueryResult<GetResumeImprovementsQuery, GetResumeImprovementsQueryVariables>;